export const HOST_DETAILS_PATH = '/new/hosts/:id';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/routes/HostDetails/constants.js